import { MobileStepper as MuiMobileStepper } from "@mui/material";
import type { MobileStepperProps as MuiMobileStepperProps } from "@mui/material";
import type { ReactNode } from "react";

export type MobileStepperProps = Pick<
  MuiMobileStepperProps,
  "steps" | "activeStep" | "variant" | "position"
> & {
  nextButton?: ReactNode;
  backButton?: ReactNode;
};

export function MobileStepper({
  activeStep,
  steps,
  nextButton = null,
  backButton = null,
  ...props
}: MobileStepperProps) {
  return (
    <MuiMobileStepper
      {...props}
      activeStep={activeStep}
      steps={steps}
      nextButton={nextButton}
      backButton={backButton}
      slotProps={{
        progress: {
          "aria-valuenow": activeStep,
          "aria-valuemax": steps,
        },
      }}
    />
  );
}
